import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["name", "fullWidth", "color", "title", "subtitle", "bottomLabel", "error", "deviceSize", "focused", "inputRef", "value", "labelAlign"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import { Box, Typography } from '@mui/material';
import { Icon } from '@elements/icon';
import { StyledCheckboxBase, StyledCheckboxLabel, StyledFormControl, StyledFormHelperErrorText, StyledFormHelperText, StyleFromHelperWrapper } from './checkbox-field.styles';
import checkedIcon from '@images/checkbox-checked.svg';
import uncheckedIcon from '@images/checkbox-unchecked.svg';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var CheckboxField = function CheckboxField(_ref) {
  var name = _ref.name,
      fullWidth = _ref.fullWidth,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'white' : _ref$color,
      title = _ref.title,
      subtitle = _ref.subtitle,
      bottomLabel = _ref.bottomLabel,
      error = _ref.error,
      deviceSize = _ref.deviceSize,
      focused = _ref.focused,
      inputRef = _ref.inputRef,
      value = _ref.value,
      labelAlign = _ref.labelAlign,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var inputName = name && "".concat(name, "-checkboxfield");
  var isError = !!error;
  var literalProps = {
    htmlFor: inputName,
    id: inputName,
    errorId: inputName && "".concat(inputName, "-error-text")
  };
  return /*#__PURE__*/_jsxs(StyledFormControl, {
    error: isError,
    fullWidth: fullWidth,
    focused: focused,
    children: [/*#__PURE__*/_jsx(StyledCheckboxLabel, {
      labelAlign: labelAlign,
      control: /*#__PURE__*/_jsx(StyledCheckboxBase, _objectSpread(_objectSpread({
        inputProps: {
          type: 'checkbox',
          id: literalProps.id
        },
        error: error || '',
        id: literalProps.id,
        "aria-describedby": inputName,
        name: name,
        fullWidth: fullWidth,
        icon: /*#__PURE__*/_jsx(Icon, {
          src: uncheckedIcon,
          width: 18,
          height: 18
        }),
        checkedIcon: /*#__PURE__*/_jsx(Icon, {
          src: checkedIcon,
          width: 18,
          height: 18
        })
      }, restProps), {}, {
        type: "checkbox"
      })),
      label: /*#__PURE__*/_jsxs(Box, {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(Typography, {
          variant: "body1",
          fontWeight: 500,
          children: title
        }), subtitle && /*#__PURE__*/_jsx(Typography, {
          variant: "caption1",
          color: "abandonedSpaceship",
          children: subtitle
        })]
      })
    }), isError && /*#__PURE__*/_jsx(StyleFromHelperWrapper, {
      children: /*#__PURE__*/_jsx(StyledFormHelperErrorText, {
        id: literalProps.errorId,
        children: error
      })
    }), bottomLabel && !isError ? /*#__PURE__*/_jsx(StyleFromHelperWrapper, {
      children: /*#__PURE__*/_jsx(StyledFormHelperText, {
        $color: color,
        children: bottomLabel
      })
    }) : null]
  });
};

export { CheckboxField };